module.exports = __webpack_public_path__ + "img/03-Express.4ad54e8b.jpeg";